<template>
    <Layout :content-class="'content--centered'">
        <div class="not-found">
            <h1 class="not-found__header">404</h1>
            <p class="not-found__descr">Oops! Order not found</p>
            <RouterLink to="/">Back to orders</RouterLink>
        </div>
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';

export default {
    name: 'OrderNotFoundPage',
    components: {
        Layout,
    },
};
</script>

<style lang="scss" src="./OrderNotFoundPage.scss"></style>
